<template>
  <v-app-bar
    class="header"
    app
    color="white"
    :height="height"
    flat
    style="border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important"
  >
    <v-app-bar-nav-icon
      @click="$emit('input', true)"
      v-if="isTemporary && isAuth"
    ></v-app-bar-nav-icon>
    <v-container class="d-flex justify-center" v-if="isUser">
      <div class="body-2 text-center">
        EL CHEAPO 24 HOUR MOBILE LOCKSMITH & ROAD SERVICES <br />
        3026 Midway drive, San Diego CA 92110 <br />Locksmith license LCO#7316
      </div>
    </v-container>
    <div class="d-flex align-center" v-else style="width: 100%">
      <v-list-item v-if="!isAuth">
        <v-list-item-content>
          <v-list-item-title class="title"> EL CHEAPO </v-list-item-title>
          <v-list-item-subtitle> Jobs Management System </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <div v-else class="header-title">
        {{ title }}
      </div>
      <v-spacer />
      <template v-if="!$route.meta.hideHeader">
        <template v-if="isTemporary">
          <template v-if="isAuth">
            <Notification></Notification>
            <v-btn text @click="logout" icon>
              <v-icon> mdi-lock-open </v-icon>
            </v-btn>
          </template>
          <v-btn text @click="$router.push('/login')" v-else icon>
            <v-icon> mdi-account </v-icon>
          </v-btn>
        </template>
        <template v-else>
          <template v-if="isAuth">
            <Notification></Notification>
            <v-btn text @click="logout">Logout</v-btn>
          </template>
          <v-btn text v-else @click="$router.push('/login')">Login</v-btn>
        </template>
      </template>
    </div>
  </v-app-bar>
</template>

<script>
import { auth } from "../assets/js/firebase";
import Notification from "./Notification.vue";
import headers from "../assets/js/headers";
export default {
  components: { Notification },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAuth: false,
      isMobile: window.innerWidth < 768,
    };
  },
  computed: {
    height() {
      return this.isUser && this.isMobile ? "130px" : "67px";
    },
    isUser() {
      let { name } = this.$route;
      let routes = ["job-cancel", "job-confirm", "technician-close-out"];
      return routes.indexOf(name) != -1;
    },
    isTemporary() {
      return window.innerWidth < 1200;
    },
    title() {
      let { name } = this.$route;
      return headers[name];
    },
  },
  methods: {
    notification() {
      const vm = this;
      window.Notification.requestPermission().then(function (permission) {
        vm.$root.alert(permission);
        console.log(permission);
      });
    },
    logout() {
      auth.signOut();
    },
  },
  mounted() {
    const vm = this;
    auth.onAuthStateChanged((user) => {
      vm.isAuth = user !== null;
    });
  },
};
</script>

<style lang="scss">
.header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  .subtitle-1 {
    line-height: 1em;
  }
  .header-title {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0125em;
    font-family: "Roboto", sans-serif;
    @media only screen and (max-width: 600px) {
      font-size: 14px !important;
    }
  }
}
</style>
